import { Link } from "wouter";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { XCircle, ArrowLeft } from "lucide-react";

export default function CheckoutCancelled() {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-6">
      <Card className="max-w-md w-full" data-testid="card-checkout-cancelled">
        <CardContent className="pt-8 text-center">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-muted mb-6">
            <XCircle className="w-8 h-8 text-muted-foreground" />
          </div>
          <h1 className="text-2xl font-bold mb-2" data-testid="text-cancelled-headline">
            No worries!
          </h1>
          <p className="text-muted-foreground mb-8" data-testid="text-cancelled-message">
            Your checkout was cancelled. No charges were made. Changed your mind? You can always start with our free plan and upgrade later.
          </p>
          <div className="flex flex-col gap-3">
            <Link href="/dashboard">
              <Button size="lg" className="w-full" data-testid="button-try-free">
                Try Free Plan
              </Button>
            </Link>
            <Link href="/pricing">
              <Button variant="outline" size="lg" className="gap-2 w-full" data-testid="button-back-to-pricing">
                <ArrowLeft className="w-4 h-4" />
                Back to Pricing
              </Button>
            </Link>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
